import { gql } from "@apollo/client";

import { PROJECT_FIELDS } from "../fragments";
import { graphql } from "../../gql/gql";

export const PROJECT_CREATE = gql`
  ${PROJECT_FIELDS}
  mutation ProjectCreate($data: CreateProjectInput!) {
    projectCreate(data: $data) {
      ...ProjectFields
    }
  }
`;

export const PROJECT_UPDATE = graphql(`
  mutation ProjectUpdate($data: ProjectUpdateInput!, $projectId: String!) {
    projectUpdate(data: $data, projectId: $projectId) {
      id
      name
      status
      public
      directory {
        id
      }
    }
  }
`);

export const PROJECT_DELETE = graphql(`
  mutation ProjectDelete($projectId: String!) {
    projectDelete(projectId: $projectId) {
      id
    }
  }
`);

export const PROJECT_COPY = graphql(`
  mutation ProjectCopy($projectId: String!) {
    projectCopy(projectId: $projectId) {
      id
    }
  }
`);

export const PROJECT_DELETE_DATA = graphql(`
  mutation ProjectDeleteData($projectId: String!) {
    projectDeleteData(projectId: $projectId) {
      id
    }
  }
`);
